




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BlockView from '../components/blockView.vue';
import { goodsLogistics } from "@/utils/api";
// import { jumpPage } from "@/utils/index";

@Component({
  components:{
    BlockView
  }
})
export default class Performance extends Vue {
  @Prop(Object) goodsInfo!: object;
  @Watch('goodsInfo',{immediate:true,deep:true})
  onChangGoodsInfo(newVal: object){
    this.logisticsData=newVal;
  }
  logisticsData: object = {};//服务与履约数据
  logistics: Array<object> = [];//运费模板数据
  $bus:any;
  created () {
    this.goodsLogistics();
  }
  /* 运费模板 */
  goodsLogistics(){
    goodsLogistics().then((data: any)=>{
      data.forEach(item=>{
        item['templateId']=item['templateId'].toString();
      })
      this.logistics=data;
    })
  }
  // 跳转运费
  jumpPageBtn(){
    this.$confirm('未保存的内容将丢失，确认离开吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      // jumpPage('freight_manage','freight_product','/freightManagement/freight/product');
      this.$router.push({path:'/freightManagement/freight/product',query:{}})
    }).catch(() => {});
  }
}
